<template>
  <div class="container">
    <div class="title">网站信息</div>
    <div class="wrap">
      <el-row>
        <el-col
          :lg="16"
          :md="20"
          :sm="24"
          :xs="24">
          <el-form
            :model="form"
            status-icon
            ref="form"
            label-width="100px"
            @submit.native.prevent>

            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>页面设置</span>
              </div>

              <el-form-item label="关于我们" prop="page_about">
                <el-input size="medium" v-model="form.page_about" placeholder="请填关于我们的网页地址"></el-input>
              </el-form-item>
              <el-form-item label="联系我们" prop="page_contact">
                <el-input size="medium" v-model="form.page_contact" placeholder="请填联系我们的网页地址"></el-input>
              </el-form-item>
            </el-card>

            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>基础信息</span>
              </div>

              <el-form-item label="联系电话" prop="phone">
                <el-input size="medium" v-model="form.phone" placeholder="请填公司联系电话"></el-input>
              </el-form-item>
              <el-form-item label="工作时间" prop="time">
                <el-input size="medium" v-model="form.time" placeholder="请填工作时间"></el-input>
              </el-form-item>
              <el-form-item label="公司地址" prop="time">
                <el-input size="medium" v-model="form.address" placeholder="请填公司地址"></el-input>
              </el-form-item>
              <el-form-item label="版权信息" prop="copyright">
                <el-input size="medium" v-model="form.copyright" placeholder="请填写版权信息"></el-input>
              </el-form-item>
              <el-form-item label="备案信息" prop="svr_record">
                <el-input size="medium" v-model="form.svr_record" placeholder="请填写备案信息"></el-input>
              </el-form-item>
            </el-card>

            <el-card class="box-card">
              <!-- 案例设置 -->
              <div slot="header" class="clearfix">
                <span>案例信息</span>
              </div>

              <el-form-item label="案例横幅" prop="sc_banner">
                <uploader ref="uploader" v-model="form.sc_banner"/>
                <el-input size="medium" v-model="form.sc_banner" placeholder="案例横幅地址"></el-input>
              </el-form-item>
              <el-form-item label="案例标签" prop="tags">
                <tags ref="tags" v-model="form.tags" :defaultSelection="form.tags"/>
              </el-form-item>
            </el-card>

            <el-form-item class="submit">
              <el-button type="primary" @click="submitForm('form')">保 存</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
import settingApi from '../models/settings'

import Tags from '../../b_showcase/views/Tags'
import Uploader from '../../Common/components/file/uploader'

export default {
  components: {
      Tags,
      Uploader,
  },
  data() {
    return {
      form: {
        page_about: '',
        page_contact: '',
        phone:'',
        time: '',
        address: '',
        copyright: '',
        svr_record: '',
        tags: [],
      },
    }
  },
  methods: {
    async submitForm(formName) {
      try {
        const res = await settingApi.updateGlobal(this.form)
            if (res.error_code === 0) {
                this.$message.success(`${res.msg}`)
            }
        } catch (error) {
            console.log(error)
        }
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.refs.tinymce.clear()

      this.tagSelection = []
      this.$refs.tags.updateTags()
    },
  },
  async mounted() {
    this.form = await settingApi.getGlobal()
  }
}
</script>

<style lang="scss" scoped>
.container {
  .title {
    height: 59px;
    line-height: 59px;
    color: $parent-title-color;
    font-size: 16px;
    font-weight: 500;
    text-indent: 40px;
    border-bottom: 1px solid #dae1ec;
  }

  .wrap {
    padding: 20px;
  }

  .submit {
    float: left;
  }

  .box-card {
    margin-bottom: 20px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }
}
</style>
